import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../api/ApiRoutes";
import { bonusAdminBody } from "./bonusAdminBody";
import type { CampaignIn } from "../../components/Promotions/DynamicBonuses/types";

type StoredToken = { AccessToken?: string };

async function fetchCampaignClone(campaignId: string): Promise<CampaignIn> {
  const tokenString = localStorage.getItem("token");
  const token: StoredToken | null = tokenString ? JSON.parse(tokenString) : null;
  const instance = createPrivateAdminPanelInstance(token?.AccessToken);
  const url = API_ROUTES.CLONE_DYNAMIC_BONUS_CAMPAIGN.replace("{campaign_id}", campaignId);
  const response = await instance.get(url);
  const clone = bonusAdminBody<CampaignIn>(response);
  if (!clone) {
    throw new Error("Campaign clone preview not found");
  }
  return clone;
}

export const getCampaignCloneQueryKey = (campaignId: string) =>
  ["CLONE_DYNAMIC_BONUS_CAMPAIGN", campaignId] as const;

export const useGetCampaignClone = (campaignId: string) => {
  return useQuery<CampaignIn>({
    queryKey: getCampaignCloneQueryKey(campaignId),
    queryFn: () => fetchCampaignClone(campaignId),
    enabled: Boolean(campaignId),
    staleTime: 1000 * 60,
    refetchOnWindowFocus: false,
  });
};
